import React, { useState } from "react";
import "./contact.css";
import { Link } from "react-router-dom";
import {
  FaInstagram,
  FaTwitter,
  FaWhatsapp,
  FaGithub,
  FaLinkedinIn,
  FaGlobe,
  FaCodepen,
} from "react-icons/fa";
import Swal from "sweetalert2";

const Contacts = () => {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [errors, setErrors] = useState({});
  const [isSending, setIsSending] = useState(false);
  const apiKey = process.env.REACT_APP_API_KEY;

  const handleSubmit = (e) => {
    e.preventDefault();

    const errors = {};

    if (name.trim().split(" ").length < 2) {
      errors.name = "Please enter at least two names";
    }

    if (message.trim().length < 10) {
      errors.message = "Please enter at least 10 characters";
    }

    if (Object.keys(errors).length > 0) {
      setErrors(errors);
      return;
    }

    setIsSending(true);

    fetch("https://api.web3forms.com/submit", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        apikey: "",
        name,
        email,
        message,
      }),
    })
      .then((response) => response.json())
      .then((data) => {
        console.log(data);
        const Toast = Swal.mixin({
          toast: true,
          position: "center",
          showConfirmButton: false,
          timer: 3000,
          timerProgressBar: true,
          didOpen: (toast) => {
            toast.addEventListener("mouseenter", Swal.stopTimer);
            toast.addEventListener("mouseleave", Swal.resumeTimer);
          },
        });
        setIsSending(false);
        Toast.fire({
          icon: "success",
          title: "Email Sent Successfully",
        });
        setTimeout(() => {
          setName("");
          setEmail("");
          setMessage("");
        }, 3000);
      })
      .catch((error) => {
        console.error("Error:", error);
        const Toast = Swal.mixin({
          toast: true,
          position: "center",
          showConfirmButton: false,
          timer: 3000,
          timerProgressBar: true,
          didOpen: (toast) => {
            toast.addEventListener("mouseenter", Swal.stopTimer);
            toast.addEventListener("mouseleave", Swal.resumeTimer);
          },
        });

        Toast.fire({
          icon: "error",
          title: "Something went wrong",
        });
        setIsSending(false);
      });
    setTimeout(() => {
      setName("");
      setEmail("");
      setMessage("");
    }, 3000);
  };

  return (
    <div className="root-container1">
      <div className="container mt-2">
        <h2 className="text-center mb-3">Contact me </h2>
        <div>
          <div className="contact-form-wrapper d-flex justify-content-center">
            <form onSubmit={handleSubmit} className="contact-form border">
              <div className="my-3">
                <input
                  type="text"
                  className={`form-control rounded mb-3 form-input ${
                    errors.name ? "border-danger" : ""
                  }`}
                  id="name"
                  placeholder="Name"
                  required
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                />
                {errors.name && (
                  <small className="text-danger">{errors.name}</small>
                )}
              </div>
              <div className="my-3">
                <input
                  type="email"
                  className="form-control rounded mb-3 form-input"
                  placeholder="Email"
                  required
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
              </div>
              <div className="my-3">
                <textarea
                  id="message"
                  className={`form-control rounded mb-3 form-input ${
                    errors.name ? "border-danger" : ""
                  }`}
                  rows="5"
                  cols="40"
                  placeholder="Talk to me"
                  required
                  value={message}
                  onChange={(e) => setMessage(e.target.value)}
                ></textarea>
                {errors.message && (
                  <small className="text-danger">{errors.message}</small>
                )}
              </div>
              <div className="submit-button-wrapper">
                <input
                  type="submit"
                  value={isSending ? `Sending...` : "Send"}
                  disabled={isSending}
                />
              </div>
            </form>
          </div>
          <div className="text-center">
            <Link to={"https://www.instagram.com/mmyykkeee"} target="_blank">
              <div className="socials-item socials-item1">
                <FaInstagram />
              </div>
            </Link>
            <Link to={"https://twitter.com/_m_yke_"} target="_blank">
              <div className="socials-item socials-item2">
                <FaTwitter />
              </div>
            </Link>
            <Link
              to={
                "https://api.whatsapp.com/send/?phone=%2B254704472009&text&type=phone_number&app_absent=0"
              }
              target="_blank"
            >
              <div className="socials-item socials-item3">
                <FaWhatsapp />
              </div>
            </Link>
            <Link to={"https://github.com/mmmyykkeee"} target="_blank">
              <div className="socials-item socials-item4">
                <FaGithub />
              </div>
            </Link>
            <Link
              to={"https://www.linkedin.com/in/mmyykkee/"}
              target="_blank"
            >
              <div className="socials-item socials-item5">
                <FaLinkedinIn />
              </div>
            </Link>
            <Link to={"https://michael-pied.vercel.app/"} target="_blank">
              <div className="socials-item socials-item6">
                <FaGlobe />
              </div>
            </Link>
            <Link
              to={"https://codepen.io/mmmyyykkkeee/pen/dygjzjE"}
              target="_blank"
            >
              <div className="socials-item socials-item7">
                <FaCodepen />
              </div>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contacts;
